import { BehanceEmbed } from './embeds/BehanceEmbed.js';
import { CanvaEmbed } from './embeds/CanvaEmbed.js';
import { CodePenEmbed } from './embeds/CodePenEmbed.js';
import { CodeSandboxEmbed } from './embeds/CodeSandboxEmbed.js';
import { DescriptEmbed } from './embeds/DescriptEmbed.js';
import { FacebookEmbed } from './embeds/FacebookEmbed.js';
import { FigmaEmbed } from './embeds/FigmaEmbed.js';
import { GitHubGistEmbed } from './embeds/GitHubGistEmbed.js';
import { InstagramEmbed } from './embeds/InstagramEmbed.js';
import { LinkedInEmbed } from './embeds/LinkedInEmbed.js';
import { LoomEmbed } from './embeds/LoomEmbed.js';
import { PinterestEmbed } from './embeds/PinterestEmbed.js';
import { ReplitEmbed } from './embeds/ReplitEmbed.js';
import { RiveEmbed } from './embeds/RiveEmbed.js';
import { SoundCloudEmbed } from './embeds/SoundCloudEmbed.js';
import { SplineEmbed } from './embeds/SplineEmbed.js';
import { SpotifyEmbed } from './embeds/SpotifyEmbed.js';
import { StackBlitzEmbed } from './embeds/StackBlitzEmbed.js';
import { TikTokEmbed } from './embeds/TikTokEmbed.js';
import { TwitterEmbed } from './embeds/TwitterEmbed.js';
import { VimeoEmbed } from './embeds/VimeoEmbed.js';
import { YouTubeEmbed } from './embeds/YouTubeEmbed.js';
import { extractContentInfoFromUrl, } from 'semantic-url-parser';
const embedComponentMap = {
    BEHANCE_GALLERY: BehanceEmbed,
    CANVA_DESIGN: CanvaEmbed,
    CODEPEN_PEN: CodePenEmbed,
    CODESANDBOX_DEVBOX: CodeSandboxEmbed,
    CODESANDBOX_SANDBOX: CodeSandboxEmbed,
    DESCRIPT_PROJECT: DescriptEmbed,
    FACEBOOK_POST: FacebookEmbed,
    FIGMA_BOARD: FigmaEmbed,
    FIGMA_DESIGN: FigmaEmbed,
    FIGMA_FILE: FigmaEmbed,
    FIGMA_PROTOTYPE: FigmaEmbed,
    GITHUB_GIST: GitHubGistEmbed,
    INSTAGRAM_POST: InstagramEmbed,
    INSTAGRAM_REEL: InstagramEmbed,
    LINKEDIN_FEED_POST: LinkedInEmbed,
    LOOM_VIDEO: LoomEmbed,
    PINTEREST_PIN: PinterestEmbed,
    REPLIT_REPL: ReplitEmbed,
    RIVE_FILE: RiveEmbed,
    SOUNDCLOUD_AUDIO_TRACK: SoundCloudEmbed,
    SPLINE_SHARED_FILE: SplineEmbed,
    SPOTIFY_ALBUM: SpotifyEmbed,
    SPOTIFY_ARTIST: SpotifyEmbed,
    SPOTIFY_AUDIO_TRACK: SpotifyEmbed,
    SPOTIFY_EPISODE: SpotifyEmbed,
    SPOTIFY_PLAYLIST: SpotifyEmbed,
    SPOTIFY_SHOW: SpotifyEmbed,
    STACKBLITZ_PROJECT: StackBlitzEmbed,
    TIKTOK_VIDEO: TikTokEmbed,
    TWITTER_STATUS: TwitterEmbed,
    VIMEO_VIDEO: VimeoEmbed,
    X_STATUS: TwitterEmbed,
    YOUTUBE_SHORT_VIDEO: YouTubeEmbed,
    YOUTUBE_VIDEO: YouTubeEmbed,
};
export const getEmbedComponent = (contentInfo) => {
    const key = `${contentInfo.site}_${contentInfo.contentType}`;
    return embedComponentMap[key];
};
export const isEmbeddableUrl = (url) => {
    const contentInfo = extractContentInfoFromUrl(url);
    if (!contentInfo) {
        return false;
    }
    const key = `${contentInfo.site}_${contentInfo.contentType}`;
    // Google Docs do not have their own component but leverage the default one and the embedUrl returned from the API
    return Boolean(embedComponentMap[key]) || contentInfo.site === 'GOOGLE_DOCS';
};
//# sourceMappingURL=utilities.js.map